import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";

/**
 * Stripe.js is loaded when a payment form is shown - never as a side effect of importing a page.
 * (`@stripe/stripe-js` itself injects js.stripe.com on import; the `/pure` entry does not, and
 * `loadStripe` is only called here, once, from the first form that needs it.) Every other route - the
 * public onboarding page above all - must not talk to Stripe or set its cookies.
 */
let promise: Promise<Stripe | null> | null = null;

export const isStripeKeyConfigured = (key: string | undefined): key is string => !!key && key !== "pk_test_your_key_here";

export function getStripePromise(key: string | undefined): Promise<Stripe | null> | null {
  if (!isStripeKeyConfigured(key)) return null;
  if (!promise) promise = loadStripe(key);
  return promise;
}
